import React from 'react';
import styled from 'styled-components';
import { palette } from '../../../system/styles/styles';
import moment from 'moment';
import { useDispatch, useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { changedState, checkStar, selectedCandidate } from '../../../redux/actions/applicantActions';
import { ClockOutline } from 'styled-icons/evaicons-outline';
import { Star as Gold } from 'styled-icons/boxicons-solid';
import { Star as Silver } from 'styled-icons/boxicons-regular';

const MainApplicant = styled.article`
  background-color: ${palette.white};
  box-shadow: 0 2px 15px 0 rgba(0, 0, 0, 0.16);
  //height: 100px;
  border-radius: 8px;
  position: relative;
  margin-bottom: 24px;
  padding-top: 1%;
  .input_check {
    width: 2vh !important;
    margin: 1%;
    position: absolute;
    padding: 5%;
    z-index: 100000;
    margin: 1%;
  }
  .applicant-box {
    position: relative;
    display: inline-grid;
    grid-template-rows: 70px 30px;
    width: 100%;
    border: none;
    cursor: pointer;
  }
  .applicant-box h4 {
    margin: auto 10px;
    font-size: 16px;
    color: ${palette.black};
    text-align: center;
  }
  .applicant-date {
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .applicant-date svg {
    width: 20px;
    height: 20px;
    margin-left: 8px;
  }
  .applicant-date p {
    color: ${palette.black};
    margin: 0px 0px 0px 2px;
    font-size: 16px;
    display: flex;
  }
`;

const Applicant = (props) => {
  const dispatch = useDispatch();

  const { t } = useTranslation(['applicant']);
  const SaveCandidate = useSelector((state) => state?.vacancy?.SaveCandidate);
  const Multi_Select_Candidate = useSelector((state) => state?.applicant?.Array_Candidate_Multiselect);
  const jobs = useSelector((state) => state?.jobs);
  const claims = useSelector((state) => state?.auth?.claims);
  const {
    idColumn,
    _column,
    data,
    inputcheck,
    info,
    setDownload,
    idVacancy,
    key,
    _sendComment,
    updateComment,
    _postStar,
    _updateStar,
    className,
    Open_ClosedModal,
    comboBox_Fuction,
  } = props;

  const [state, setState] = React.useState({
    time: moment(),
    showModal: false,
    numPages: null,
    pageNumber: 1,
    downloadable: '',
    column: _column,
    checked: false,
  });

  const ToggleModal = async () => {
    const data = [];
    dispatch(changedState(info));
    dispatch(checkStar(info));
    dispatch(selectedCandidate(info, idColumn));
    Open_ClosedModal(data);
  };

  const handleChange = (e) => {
    const name = e.target.name;
    setState((prevState) => ({ ...prevState, [name]: !state.checked }));
  };

  const getNumberArray = (start = 0) => {
    const array = [];
    if (start !== 0) {
      start = start.promedio;
    }
    if (start === 0) {
      return (
        <p>
          <Silver color="gold" />0
        </p>
      );
    } else {
      return (
        <p>
          <Gold color="gold" />
          {start}
        </p>
      );
    }
  };

  return (
    <MainApplicant>
      <input
        style={{ display: inputcheck ? 'block' : 'none' }}
        type="checkbox"
        name="check"
        className="input_check"
        checked={
          Multi_Select_Candidate ? (Multi_Select_Candidate.find((o) => o.idUser === info.docID) ? true : false) : false
        }
        onClick={(e) => {
          handleChange(e);
          // console.log(info.docID ? info.docID : "canidates")
          comboBox_Fuction({ idUser: info.docID });
        }}
      />

      <div className="applicant-box">
        <h4 onClick={() => ToggleModal()}>{`${info.names} ${info.lastNames}`}</h4>
        <div className="applicant-date" onClick={() => ToggleModal()}>
          <ClockOutline />
          <p>
            {info.time
              ? moment(+info.time)
                  .locale('es')
                  .format('MMM DD')
              : '--'}
          </p>
          {getNumberArray(info.stars)}
        </div>
      </div>
    </MainApplicant>
  );
};

export default Applicant;
